import type { FC } from "preact/compat";
import { RouterProvider } from "react-router-dom";
import { AppStatus } from "./components";
import router from "./router";
import { AppProvider, store } from "./store";

const App: FC = () => (
    <AppProvider value={store}>
        <AppStatus />
        <RouterProvider router={router} />
    </AppProvider>
);

export default App;
